import { useMemo } from "react";
import generateRandomData from "../../services/randomDataGenerator";

function useRandomData(dataType = "ALN") {
  return useMemo(() => generateRandomData(dataType), [dataType]);
}

export default useRandomData;
